import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReturnObject } from '../../model/returnobject';
import { StatusMessagesService } from '../../shared/statusmessage.service';
import { SysadminServiceService } from '../../shared/sysadmin-service.service';

export interface DispensationDialogData {
  assignmentNumber: string
  hasDispensation: boolean
}

@Component({
  selector: 'app-dispensation',
  templateUrl: './dispensation-dialog.html',
  styleUrls: ['./dispensation-dialog.scss']
})

export class DispensationDialog implements OnInit {
  @Input() showMe: boolean = false;
  @Input() assignmentNumber: string = '';
  @Input() hasDispensation: boolean = false;
  @Output() onCloseDlg = new EventEmitter<boolean>();

  isSaving: boolean = false;

  constructor(
    private sysadminService: SysadminServiceService,
    private statusMessagesService: StatusMessagesService  ) { }

  ngOnInit() {

  }

  giveDispensation() {
    this.isSaving = true;
    this.sysadminService.giveDispensation(this.assignmentNumber)
      .subscribe({
        next: (msg: ReturnObject<string>) => {
          if (msg.isFailure) {
            this.statusMessagesService.showToasterError('Error', msg.failureMessage);
            return;
          }
          this.statusMessagesService.showToasterInfo('Saved', msg.value);
          this.finishClose(true);
        },
        error: (err) => {
          this.statusMessagesService.showHttpError(err);
          this.isSaving = false;
        },
        complete: () => {
          this.isSaving = false;
        }
      });
  }

  removeDispensation() {
    this.isSaving = true;
    this.sysadminService.removeDispensation(this.assignmentNumber)
      .subscribe({
        next: (msg: ReturnObject<string>) => {
          if (msg.isFailure) {
            this.statusMessagesService.showToasterError('Error', msg.failureMessage);
            return;
          }
          this.statusMessagesService.showToasterInfo('Removed', msg.value);
          this.finishClose(true);
        },
        error: (err) => {
          this.statusMessagesService.showHttpError(err);
          this.isSaving = false;
        },
        complete: () => {
          this.isSaving = false;
        }
      });
  }

  closeDialog(isYes: boolean) {
    if (this.isSaving) {
      return;
    }

    if (isYes) {
      if (!this.hasDispensation) {
        this.giveDispensation();
      } else if (this.hasDispensation) {
        this.removeDispensation();
      }
      return;
    }

    this.finishClose(false);
  }

  private finishClose(dataChanged: boolean) {
    this.onCloseDlg.emit(dataChanged);
    this.showMe = false;
  }
}
